import { Protocol } from './index';
import { Category } from '../constants';

const socialFiGame: Protocol[] = [
  {
    name: 'RealGO',
    url: 'https://www.myreal.io',
    logoPath: '/logos/RealGo_Logo_400x400.png',
    category: Category.SocialFiGame,
    twitterUrl: 'https://x.com/Realgo2moon',
  },
];

export { socialFiGame };
